import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class ClusterCommunityDto extends EpimsBaseEntityDto {
	@IsNotEmpty() ClusterCommunityId: string;
	@IsNotEmpty() ClusterCommunityName: string;
	@IsNotEmpty() StateId: string;
	@IsNotEmpty() LgaId: string;
	@IsNotEmpty() CommunityId: string;
	@IsNotEmpty() GMOUId: string;
	@IsNotEmpty() ClusterId: string;
}
